import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { RootState } from "../../../store/rootReducer";
import { allowSave, Option } from "../../../store/helpers";
import { showModal } from "../../../reducers/modal/modal.actions";
import { updateBentukKerjasama } from "../../../reducers/dokumenKerjasama/dokumenKerjasama.actions";
import { fieldErrorMessage, fieldHasErrors } from "../../../store/errorHandler";
import { PermissionMenuName } from "../../../interfaces/UserRole";

export const FormBentuk = () => {
  const dispatch = useDispatch();
  
  const errors = useSelector((state: RootState) => state.dokumenKerjasama.error);
  const isLoading = useSelector((state: RootState) => state.dokumenKerjasama.isLoading);
  const listBentukKerjasama = useSelector((state: RootState) => state.bentukKerjasama.listBentukKerjasama);
  const listIdBentukKerjasama = useSelector((state: RootState) => state.dokumenKerjasama.selectedDokumenKerjasama?.KERMA_ID);
  const listDetailBentukKerjasama = useSelector((state: RootState) => state.dokumenKerjasama.selectedDokumenKerjasama?.BENTUK_KERJASAMA);
  const [pelaksanaOptions, setBentukKerjasamaOptions] = useState<Option[]>([]);
  
  const [selectedBentukKerjasama, setSelectedBentukKerjasama] = useState<Option | null>(null);

  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS);
  const canSave = allowSave(role, 2);

  const onChangeBentukKerjasama = (e: Option | null) => {
    setSelectedBentukKerjasama(e);
  }

  const addNewBentukKerjasama = () => {
    if (!selectedBentukKerjasama || !listIdBentukKerjasama || typeof listDetailBentukKerjasama === 'undefined' || typeof listIdBentukKerjasama === 'undefined') {
      dispatch(showModal(
        'Bentuk kerjasama gagal ditambahkan',
        'Mohon pilih bentuk kerjasama terlebih dahulu.'
      ));
      return;
    }

    if (typeof listIdBentukKerjasama.find((search) => search === parseInt(selectedBentukKerjasama.value)) !== 'undefined') {
      dispatch(showModal(
        'Bentuk kerjasama gagal ditambahkan',
        'Bentuk kerjasama sudah terdaftar sebagai bentuk kerjasama dalam dokumen kerjasama ini.'
      ));
      return;
    }

    const newBentukKerjasama = listBentukKerjasama.find((search) => search.KERMA_ID === parseInt(selectedBentukKerjasama.value));

    if (newBentukKerjasama) {
      const newBentukKerjasamaIdList = [...listIdBentukKerjasama];
      const newBentukKerjasamaDetailList = [...listDetailBentukKerjasama];
      newBentukKerjasamaIdList.push(newBentukKerjasama.KERMA_ID);
      newBentukKerjasamaDetailList.push(newBentukKerjasama);
      dispatch(updateBentukKerjasama(newBentukKerjasamaIdList, newBentukKerjasamaDetailList));
    }
  }

  const removeBentukKerjasama = (id: number) => {
    if (!listIdBentukKerjasama || typeof listDetailBentukKerjasama === 'undefined' || typeof listIdBentukKerjasama === 'undefined') {
      dispatch(showModal(
        'Bentuk kerjasama gagal dihapus',
        'Sistem belum berhasil memuat data. Mohon coba kembali dalam beberapa saat.'
      ));
      return;
    }

    const newBentukKerjasamaIdList = [...listIdBentukKerjasama];
    const newBentukKerjasamaDetailList = [...listDetailBentukKerjasama];
    const removeTargetId = newBentukKerjasamaIdList.findIndex((search) => search === id);
    const removeTargetList = newBentukKerjasamaDetailList.findIndex((search) => search.KERMA_ID === id);

    newBentukKerjasamaIdList.splice(removeTargetId, 1);
    newBentukKerjasamaDetailList.splice(removeTargetList, 1);

    dispatch(updateBentukKerjasama(newBentukKerjasamaIdList, newBentukKerjasamaDetailList));
  }

  useEffect(() => {
    const newOptions: Option[] = [];
    listBentukKerjasama.forEach(item => {
      newOptions.push({
        value: item.KERMA_ID.toString(),
        label: item.NAMA
      });
    });
    setBentukKerjasamaOptions(newOptions);
  }, [listBentukKerjasama])

  const renderBentukKerjasama = () => {
    if (listDetailBentukKerjasama?.length === 0) {
      return (
        <tr>
          <td colSpan={2} style={{textAlign: 'center'}}>
            Data tidak ditemukan, silahkan tambah anggota baru.
          </td>
        </tr>
      );
    }

    return listDetailBentukKerjasama?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item.NAMA}</td>
          <th>
            <button className="btn btn-danger btn-xs" disabled={isLoading || !canSave} onClick={() => removeBentukKerjasama(item.KERMA_ID)}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      );
    });
  }

  if (typeof listDetailBentukKerjasama === 'undefined' || typeof listIdBentukKerjasama === 'undefined') return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Bentuk Kerjasama</h3>
        </div>
        <div className="box-body">
          Sedang memuat data...
        </div>
        <div className="overlay active">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Bentuk Kerjasama</h3>
        </div>
        <div className="box-body">
          <div className={`form-group ${fieldHasErrors('KERMA_ID', errors) ? 'has-error' : ''}`}>
            <label>Pilih Nama Bentuk Kerjasama</label>
            <div className="input-group">
              <Select
                isDisabled={isLoading || !canSave}
                options={pelaksanaOptions}
                value={selectedBentukKerjasama}
                onChange={onChangeBentukKerjasama}
                menuPortalTarget={document.querySelector("body")}
              />
              <span className="input-group-btn">
                <button type="button" className="btn btn-primary" disabled={isLoading || !canSave} onClick={addNewBentukKerjasama}>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <span className="help-block">{ fieldErrorMessage('KERMA_ID', errors) }</span>
          </div>
        </div>
        <div className="box-body table-responsive no-padding" style={{ maxHeight: '200px' }}>
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="sticky">Nama <span className="text-red"><b>*</b></span></th>
                <th className="sticky"></th>
              </tr>
            </thead>
            <tbody>
              {renderBentukKerjasama()}
            </tbody>
          </table>
        </div>
        <div className={`overlay ${isLoading ? 'active' : null}`}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
};
